import { ApiClient } from '../api/ApiClient';
import { store } from '../store/Store';

export async function addUserToAvailableHcpReferral(): Promise<void> {
  const { referral } = store.getState().entry;

  if (referral !== undefined && !referral.hasUserId) {
    await new ApiClient().addUserToHcpReferral({ referralId: referral.referralId });
  }
}
